<template>
  <div>
    <div v-wechat-title='"《魔卡少女樱》x《喜羊羊》联动活动开启"'></div>
    <div class="sheep-pc-page">
      <div class="logo"></div>
      <div class="title"></div>
      <div class="code"></div>
      <div class="text"></div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp, buriedLogger } from '@/utils/utils';
export default {
  components: {},
  data() {
    return {
      logger: null
    };
  },
  created() {
    const bl = buriedLogger("sakura", "小樱_喜羊羊联动PC端");
    this.logger = bl;
  },
  mounted() {
    this.$nextTick(() => {
      this.monitoringEquipment();
    });
  },
  computed: {},
  methods: {
    monitoringEquipment() {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `https://h5.qingcigame.com/sakura/sheep/enter${getTimeStamp()}`
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/sakura/sheep/pc/index.vue